module.exports = __webpack_public_path__ + "img/spec-analyse-abl.d44a3d92.jpg";